const errorStyle = theme => ({
  errorArea: {    
    "text-align": "center"
  },
  errorIcon: {
    position: "relative",
    top: "5px"
  },
  close: {
    position: "relative",
    "margin-left": "5px"
  },
  errorHeader: {
    "margin-top": "0px !important",
    "margin-bottom": "0px !important",
    "padding-bottom": "0px !important",
    "padding-top": "0px !important"
  },
  errorCard: {
    "margin-top": "0px !important",
    "margin-bottom": "0px !important",
    "padding-bottom": "0px !important",
    "padding-top": "0px !important"
  }
})

export default errorStyle
